module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"レビュー運営方式","review_permission":"レビュー投稿権限","review_publication_period":"レビュー掲載期間","rating_criteria_and_impact":"評価基準および影響","review_deletion_criteria_and_appeal_procedures":"レビュー削除基準および異議申し立ての手続き"}}')
  delete Component.options._Ctor
}
